import { useEffect, useMemo } from 'react';
import { useAppSelector } from '../../../hooks';
import { selectGates } from '../../../reducers/Portal';
import { removeThemeSetting } from 'foundations-theming/utils/themeSwitcher';
export const useSyncTrellisTheme = () => {
  const gates = useAppSelector(selectGates);
  const shouldRemoveThemeSetting = useMemo(() => {
    return gates && gates.length > 0 && !gates.includes('trellis:primary');
  }, [gates]);
  useEffect(() => {
    if (shouldRemoveThemeSetting) {
      removeThemeSetting();
    }
  }, [shouldRemoveThemeSetting]);
};